module.exports = __webpack_public_path__ + "static/top-50-seal-pink-d857acd9e44762d87e6d6fd81779ca49.png";